import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { environment } from '@src/environments/environment';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': SessionHelper.getIdToken() 
  })
}

@Injectable({
  providedIn: 'root'
})

export class OrgviewService {

  constructor(private http:HttpClient) { }

  getOrg(orgId:string){
    return this.http.get<any>(environment.apiUrl+'/organization/'+orgId,httpOptions)
  }

}
